import React from "react";

import { Box, Button, Typography } from "@braintrust/braintrust-ui-components";

type MFAMethodSelectionProps = {
  onSelectOtp: () => void;
  onSelectPasskey: () => void;
  onCancel?: () => void;
};

export const MFAMethodSelection = ({
  onSelectOtp,
  onSelectPasskey,
  onCancel,
}: MFAMethodSelectionProps) => {
  return (
    <Box>
      <Typography
        component="h4"
        variant="title"
        fontWeight={400}
        sx={{ mb: 2 }}
      >
        2-step authentication
      </Typography>
      <Typography component="p" sx={{ mb: 4 }}>
        Choose how you’d like to verify your identity.
      </Typography>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Button
          variant="dark-violet"
          sx={{
            boxShadow: "0px 4px 12px 0px #5D197440 !important",
          }}
          shape="squared"
          fullWidth
          onClick={onSelectPasskey}
        >
          Use passkey
        </Button>
        <Button
          variant="secondary"
          shape="squared"
          fullWidth
          onClick={onSelectOtp}
        >
          Use authenticator app
        </Button>
        {!!onCancel && (
          <Button
            variant="secondary"
            shape="squared"
            fullWidth
            onClick={onCancel}
          >
            Cancel
          </Button>
        )}
      </Box>
    </Box>
  );
};
